import PercentageViewed from '~/utils/percentageViewed';

type thresholdOptions = {
  [key: string]: boolean;
};

export type InstanceOptions = {
  instance: PercentageViewed;
  thresholds: thresholdOptions;
};

// для всей страницы
const percentagePage = {
  instance: null as any,
  thresholds: {
    25: false,
    50: false,
    75: false,
    100: false,
  } as thresholdOptions,
};

const elementsInstances: { [key: string]: InstanceOptions } = {};

export function viewedPagePercent() {
  return percentagePage.instance ? percentagePage.instance.viewed : 0;
}

export function viewedContentPercent(selector: string): number | undefined {
  const instance = elementsInstances[selector]?.instance;
  return instance?.viewed ?? 0;
}

export function getPageObject() {
  return percentagePage;
}

export function getContentObject(selector: string): InstanceOptions | undefined {
  return elementsInstances[selector];
}

export function resetThresholdsPage() {
  percentagePage.thresholds = {
    25: false,
    50: false,
    75: false,
    100: false,
  };
}

export function percentageInit(selector?: string) {
  // отслеживаем всю страницу
  // через document.body
  if (!selector) {
    percentagePage.instance = new PercentageViewed(document.body);
  } else {
    const trackedElement: HTMLElement | null = document.querySelector(selector);

    if (trackedElement) {
      elementsInstances[selector] = {
        instance: new PercentageViewed(trackedElement),
        thresholds: {
          25: false,
          50: false,
          75: false,
          100: false,
        } as thresholdOptions,
      };
    }
  }
}
